import React from "react";
import { parseFrontmatter } from "@/lib/markdownUtils";

/**
 * Surfaces YAML frontmatter as a calm "Properties" metadata panel above a note.
 * Renders nothing when the note has no frontmatter.
 */
export default function PropertiesPanel({ markdown }) {
  const { data, hasFrontmatter } = parseFrontmatter(markdown || "");
  const keys = Object.keys(data);
  if (!hasFrontmatter || keys.length === 0) return null;

  return (
    <div className="props-panel" data-testid="vault-properties">
      <div className="props-panel-head">Properties</div>
      {keys.map((k) => (
        <div className="props-row" key={k} data-testid={`prop-${k}`}>
          <span className="props-key">{k}</span>
          <span className="props-val">
            {Array.isArray(data[k]) ? (
              data[k].map((v) => (
                <span className="props-chip" key={v}>{v}</span>
              ))
            ) : (
              String(data[k])
            )}
          </span>
        </div>
      ))}
    </div>
  );
}
